import React from 'react';

class Input extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      value: '',
      valid: '',
      change: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({
      value: event.target.value,
      valid: event.target.value ? true : false,
      change: true
    })
    //this.props.checkIfValid(event);
    let name = this.props.id
    let data = event.target.value ? true : false 
    if (!data) {
      data = !this.props.required
    }
    this.props.compStatusCheck({ [name]: data })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.value !== prevState.value && prevState.change === false) {
      return { value: nextProps.value }
    } else {
      return null
    }
  }

  componentDidMount() {
    let name = this.props.id
    let data = this.state.value ? true : false 
    if (!data) {
      data = !this.props.required
    }
    this.props.compStatusCheck({ [name]: data })
  }

  render() {
    const props = JSON.parse(JSON.stringify(this.props));
    const { datatype, label, id, unit, readOnly, required } = props;
    const nonValid = this.state.valid ? '' : 'non-valid';

    return (
      <div className='form-group row'>
        <label htmlFor={id} className="col-4 col-form-label">{label}</label>
        <div className="col-8 p-0">
          {
            readOnly ?
              <input className={`form-control ${nonValid}`} type={datatype} id={id} value={this.state.value} readOnly /> :
              <input className={`form-control ${nonValid}`} type={datatype} id={id} value={this.state.value} onChange={this.handleChange} required={required} />
          }
          <p className="form-text text-muted">{unit}</p>
        </div>
      </div>
    );
  }
}

export default Input;